import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { deepExtend } from "../../Utils/Utils";
export var Responsive = /*#__PURE__*/function () {
  function Responsive() {
    _classCallCheck(this, Responsive);

    this.maxWidth = Infinity;
    this.options = {};
    this.mode = "canvas";
  }

  _createClass(Responsive, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.maxWidth !== undefined) {
        this.maxWidth = data.maxWidth;
      }

      if (data.mode !== undefined) {
        if (data.mode === "screen") {
          this.mode = "screen";
        } else {
          this.mode = "canvas";
        }
      }

      if (data.options !== undefined) {
        this.options = deepExtend({}, data.options);
      }
    }
  }]);

  return Responsive;
}();